var EnumUtil = /** @class */ (function () {
    function EnumUtil() {
    }
    EnumUtil.toArray = function (e) {
        var result = [];
        for (var enumValue in e) {
            var isValueProperty = parseInt(enumValue, 10) >= 0;
            if (isValueProperty) {
                var item = { id: parseInt(enumValue), value: e[enumValue] };
                result.push(item);
            }
        }
        return result;
    };
    return EnumUtil;
}());
export { EnumUtil };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW51bS11dGlsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiZW51bS11dGlsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBO0lBQUE7SUFZQSxDQUFDO0lBWGlCLGdCQUFPLEdBQXJCLFVBQXdDLENBQU07UUFDMUMsSUFBSSxNQUFNLEdBQWtCLEVBQUUsQ0FBQztRQUMvQixLQUFLLElBQUksU0FBUyxJQUFJLENBQUMsRUFBRTtZQUNyQixJQUFJLGVBQWUsR0FBRyxRQUFRLENBQUMsU0FBUyxFQUFFLEVBQUUsQ0FBQyxJQUFJLENBQUMsQ0FBQztZQUNuRCxJQUFJLGVBQWUsRUFBRTtnQkFDakIsSUFBSSxJQUFJLEdBQUksRUFBRSxFQUFFLEVBQUUsUUFBUSxDQUFDLFNBQVMsQ0FBQyxFQUFFLEtBQUssRUFBRSxDQUFDLENBQUMsU0FBUyxDQUFDLEVBQWtCLENBQUM7Z0JBQzdFLE1BQU0sQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUM7YUFDckI7U0FDSjtRQUNELE9BQU8sTUFBTSxDQUFDO0lBQ2xCLENBQUM7SUFDTCxlQUFDO0FBQUQsQ0FBQyxBQVpELElBWUMifQ==